import React from "react";
import "./our-message-to-you.scss";

interface OurMessageToYouProps {

}
interface OurMessageToYouState {
    Change: boolean;
}

class OurMessageToYou extends React.Component<OurMessageToYouProps, OurMessageToYouState>{
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    getItems = () => {
    }

    render() {
        return (
            <section className="our-message-section">
                <article>
                    <h2>SİZE OLAN MESAJIMIZ</h2>
                    <p>
                        Bir gün,<span className="text-bold-italic">“Kim halis niyetle ararsa, aradığını bulur!”</span>
                        cümlesinden hareketle arayışa çıktık. Koyulduğumuz yolda, aradığımız
                        <span className="text-bold-italic">“Güneşin arkasındaki ışığı”</span> bulmada refakatçilerimiz olan,
                        <span className="highlight-word"> SEMA</span>, ZİKİR ve MEVLÂNA CELÂLEDDİN RUMİ’yi bulduk.
                        Sufi geleneğinde,
                        <span className="text-bold-italic">“Kim bulursa, o diğerlerine bulma imkânı oluşturan bir fener kulesidir”</span> denilmektedir.
                    </p>
                    <p>
                        Hep birlikte,
                        dersleri <span className="highlight-word">SEMA</span>, ZİKİR ve yaşanan hayat olan, yaşayan
                        bir <span className="highlight-word">Sema</span> okulunu oluşturuyoruz. Biz, hayatı
                        başarılı kılan mutluluk, mana, yaşam sevinci, medeni
                        cesaret ve yaşayan ilişkiler olan şeylere götüren
                        yoldayız. Evet, bu bir gerçek: Sufiler mutlu ve
                        hayatta cesaretli insanlardır!
                    </p>

                    <p>
                        Abartma gibi gözükebilir bu belki ama öyle değil.
                        Herkesin alabileceği bir şey var bu <span className="highlight-word">SEMA</span> meclisinde bence.
                        Yüz yıllardır yedi iklim dört bucağa en netameli
                        devirlerde bile hiç kandil söndürmeden <span className="text-bold">türüm türüm </span>
                        insanlık ve İslâmlık eğitimi vermiş evrensel ve herkese
                        açık bir üniversitedir bizim <span className="highlight-word">SEMA</span> dergahlarımız.
                        Sufi yolu, yaşayan bir süreç, bir hayat okuludur. Bu
                        okul, insanlara ego zırhından nasıl kurtulacağını ve güneşin
                        arkasındaki güneşi nasıl arayacağını göstermektedir.

                    </p>
                    <p>
                        Biz aradık ve aradığımızı bulduk. Daha sonra bildiklerimizi
                        başkalarına aktarmak için izin aldık. Bundan dolayı
                        çok mutluyuz ve teşekkür borçluyuz.
                        Bu <span className="highlight-word">SEMA</span> okulu derneğimiz bu teşekkürün
                        ifadesidir.
                    </p>
                </article>
            </section>
        );
    }
}

export default OurMessageToYou;